<div class="info-container">
  <div class="info-sub-container">
    <div class="info-sub-container2">
      <div class="title-container">
        <div class="title">Family Information</div>
      </div>
      <div class="content-container">
        <div class="left-panel">
          <div class="panel-l1">
            <div class="panel-l2"></div>
            <div class="panel-l3"></div>
            <div class="panel-l4"></div>
          </div>
          <div class="left-container">
            <div class="label-item">{{ title }}</div>
            <div class="image-and-properties-container">
              <div class="image-container">
                <img [src]="image" alt="item image" class="image" />
              </div>
              <sysque-properties-list
                class="properties-list-container"
                [propertiesListItems]="propertiesListItems"
                (valueChanged)="onPropertiesValueChanged($event)"
              >
              </sysque-properties-list>
            </div>
            <div class="service-type-container">
              @if (isLengthVisible) {
                <div>
                  <sysque-number-box-options-line
                    [numberBoxItems]="lengthItems"
                    [showSpinButtons]="lengthSpinButtons"
                    (valueChanged)="onLengthValueChanged($event)"
                  >
                  </sysque-number-box-options-line>
                </div>
              }
              @if (isServiceTypeVisible) {
                <div>
                  <sysque-dropdown-service-type
                    [data]="serviceTypeData"
                    [serviceTypeName]="serviceTypeName"
                    [placeholder]="serviceTypePlaceholder"
                    (valueChanged)="onServiceTypeValueChanges($event)"
                    (openContextMenu)="contextMenu.contextMenuVisibility($event)"
                  >
                  </sysque-dropdown-service-type>
                  <sysque-context-menu
                    #contextMenu
                    target="#modus-button"
                    (contextMenuItemSelected)="handleContextMenuItem($event)"
                    [menuItems]="menuItems"
                  ></sysque-context-menu>
                  @if (isLineGraphicsDialogOpen) {
                    <sysque-line-graphics [config]="lineGraphicsDialogConfig"></sysque-line-graphics>
                  }
                  @if (isCreateServiceTypeDialogOpen) {
                    <sysque-create-service-type [config]="createServiceTypeDialogConfig"></sysque-create-service-type>
                  }
                  @if (isDeleteServiceTypeDialogOpen) {
                    <sysque-delete-service-type [config]="deleteServiceTypeDialogConfig"></sysque-delete-service-type>
                  }
                </div>
              }
            </div>
            <div class="angle-container">
              @if (isAngleVisible) {
                <div>
                  <sysque-number-box-options-line
                    [numberBoxItems]="angleItems"
                    [showSpinButtons]="angleSpinButtons"
                    (valueChanged)="onAngleValueChanged($event)"
                  >
                  </sysque-number-box-options-line>
                </div>
              }
            </div>
            <div class="connectors-container">
              @if (areConnectorsVisible) {
                <div>
                  <sysque-dropdown-connectors
                    [title]="connectorsTitle"
                    [connectors]="connectorsItems"
                    (valueChanged)="onConnectorValueChanged($event)"
                  >
                  </sysque-dropdown-connectors>
                </div>
              }
              <!-- <div *ngIf="isWallTypeVisible">
                <sysque-switch-button 
                  [buttonInfo]="wallTypeButtonInfo"
                  (switchClicked)="onWallTypeClicked($event)">
                </sysque-switch-button>
              </div> -->
              @if (isHangerVisible) {
                <div class="hanger-container">
                  <sysque-switch-button [buttonInfo]="hangerButtonInfo" (switchClicked)="onHangerSwitchClicked($event)">
                  </sysque-switch-button>
                </div>
              }
            </div>
            <div class="support-discipline-container">
              @if (isSupportDisciplineVisible) {
                <div>
                  <sysque-text-area-description
                    [label]="supportDisciplineLabel"
                    [description]="supportDiscipline"
                    [height]="30"
                    (valueChanged)="onSupportDisciplineValueChanged($event)"
                  >
                  </sysque-text-area-description>
                </div>
              }
            </div>
            <div class="instance-description-container">
              <sysque-text-area-description
                [label]="instanceDescriptionLabel"
                [description]="instanceDescription"
                (valueChanged)="onInstanceDescriptionValueChanged($event)"
              >
              </sysque-text-area-description>
            </div>
            <div class="type-description-container">
              <sysque-text-area-description
                [label]="typeDescriptionLabel"
                [description]="typeDescription"
                (valueChanged)="onTypeDescriptionValueChanged($event)"
              >
              </sysque-text-area-description>
            </div>
            <div class="project-data-container">
              <sysque-switch-button
                [buttonInfo]="projectDataButtonInfo"
                (switchClicked)="onProjectDataSwitchClicked($event)"
                (optionButtonClicked)="onProjectDataButtonClicked()"
              >
              </sysque-switch-button>
            </div>
          </div>
        </div>
        <div class="right-panel">
          <div class="panel-l1">
            <div class="panel-l2"></div>
            <div class="panel-l3"></div>
            <div class="panel-l4"></div>
          </div>
          <div class="right-container">
            <sysque-datagrid-size-range
              #sizeGrid
              [dataGrid]="dataGrid"
              (selectedItems)="onSizeRangeSelectedItems($event)"
            >
            </sysque-datagrid-size-range>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="action-container">
    <div class="sysque-alert">
      @if (isWarningVisible) {
        <alert [alert]="warningAlert" (alertClosed)="hideAlert()"></alert>
      }
    </div>
    <dx-button id="apply-button" class="done" (onClick)="doneClick()" text="Done"> </dx-button>
  </div>
</div>
